import { IApplicationCommonRootComponentProps } from '../../types/applicationRootComponent';
import React, { FunctionComponent } from 'react';
import { TPageType } from '../../types/applicationContext';
import { SubsidizedCalculatorApp } from '../../../subsidizedCalculator/containers/SubsidizedCalculatorApp';
import { OfferCalculatorApp } from '../../../offerCalculator/containers/OfferCalculatorApp';
import { MortgageMiniCalculatorApp } from '../../../mortgageMiniCalculator/containers/MortgageMiniCalculatorApp';

const APP_REGISTRY: Record<TPageType, FunctionComponent<IApplicationCommonRootComponentProps>> = {
  subsidizedCalculator: SubsidizedCalculatorApp,
  offerCalculator: OfferCalculatorApp,
  mortgageMiniCalculator: MortgageMiniCalculatorApp,
};

/**
 * Корневой компонент приложения, асинхронно загружающий и отдающий нужный App для каждой страницы.
 * Использовать при рендере на сервере и гидрации на клиенте во всех фичах,
 * т.к. от этого зависит работа код-сплиттинга страниц.
 */
export const RootApplicationContainer: React.FC<IApplicationCommonRootComponentProps> = props => {
  const App = APP_REGISTRY[props.context.custom.pageType];

  return <App {...props} />;
};
